const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/system/users/$userId/edit.fields.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/system/users/$userId/edit/fields")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Edit Custom Fields",
      description: "Page title"
    })
  }
});